
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/scan",
      function () {
        return require("private-next-pages/scan/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/scan"])
      });
    }
  